import { render, staticRenderFns } from "./CtrlNumTxt.vue?vue&type=template&id=63217a85&scoped=true&"
import script from "./CtrlNumTxt.vue?vue&type=script&lang=ts&"
export * from "./CtrlNumTxt.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlNumTxt.vue?vue&type=style&index=0&id=63217a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63217a85",
  null
  
)

export default component.exports